// extracted by mini-css-extract-plugin
export var infoItem = "_tl-2";
export var title = "_tl-0";
export var value = "_tl-1";